/**
 * Плейсхолдеры меты каталога.
 *
 * Значения для них должны быть всегда: и минимальная цена, и город есть на
 * любой странице каталога. Если значения не оказалось — это баг источника
 * (цена не посчиталась, запись панели ссылается на переменную, которой на
 * этом уровне фильтра нет), и чинить надо источник.
 *
 * Здесь только две вещи: список написаний плейсхолдера цены и страховка,
 * которая не даёт решётке доехать до пользователя и сообщает о ней в
 * GlitchTip, чтобы баг было видно.
 */

/**
 * Написания плейсхолдера минимальной цены, встречающиеся в записях панели.
 * Канон — `#MIN_PRICE#`, но в части записей набрано через дефис, и до этой
 * правки такие строки уходили в HTML как есть (ТЗ on-page, T-01).
 */
export const MIN_PRICE_ALIASES = ["#MIN_PRICE#", "#MIN-PRICE#", "#PRICE#"];

/**
 * Свойство, по значениям которого подставляются цены. В текстах каталога есть
 * таблица со всеми типами крюка, а у страницы своя цена только одна — её
 * подставляет `#MIN_PRICE#`. Остальные берутся по значению фильтра.
 */
export const PROP_PRICE_PROP = "tip_kryuka";

/**
 * Плейсхолдер цены по значению фильтра: `#MIN_PRICE_NESEMNYY#`.
 * Подчёркивание после `MIN_PRICE` обязательно, поэтому обычный `#MIN_PRICE#`
 * под шаблон не попадает.
 */
const PROP_PRICE_REGEX = /#MIN_PRICE_([A-Z0-9_]+)#/g;

/** Токены цен по значениям фильтра: `#MIN_PRICE_NESEMNYY#` → `nesemnyy` */
export function findPropPriceTokens(
  text: unknown,
): { token: string; value: string }[] {
  const found = new Map<string, string>();
  const matches = String(text ?? "").matchAll(PROP_PRICE_REGEX);
  for (const match of matches) {
    found.set(match[0], match[1].toLowerCase());
  }
  return [...found].map(([token, value]) => ({ token, value }));
}

/**
 * Плейсхолдеры, которые снимать нельзя: город на главном домене выбирает
 * пользователь, и `#CITY#` доезжает до браузера намеренно — подстановку
 * делает layout (components/layouts/main).
 */
const KEEP_PLACEHOLDERS = new Set(["#CITY#", "#CITY_NAME#"]);

/**
 * Плейсхолдер панели вместе с пробелами по краям: `#MARK_RUS#`, `#MIN-PRICE#`.
 * Только верхний регистр и обязательная закрывающая решётка — якоря (`#tab-1`)
 * и hex-цвета (`#FFFFFF` без закрывающей) под шаблон не подходят.
 */
const PLACEHOLDER_REGEX = /[ \t]*#[A-Z][A-Z0-9_-]*#[ \t]*/g;

/** Плейсхолдеры без значения: и незаполненные, и с опечаткой (`#MIN_RPICE#`) */
export function findUnresolvedPlaceholders(text: unknown): string[] {
  const found = String(text ?? "").match(PLACEHOLDER_REGEX) || [];
  const tokens = found
    .map((match) => match.trim())
    .filter((token) => !KEEP_PLACEHOLDERS.has(token));
  return [...new Set(tokens)];
}

/** Снимает плейсхолдеры без значения, не трогая те, что подставляются позже */
export function stripUnresolvedPlaceholders(text: unknown): string {
  const value = String(text ?? "");
  if (!value) return "";
  return value
    .replace(PLACEHOLDER_REGEX, (match) =>
      KEEP_PLACEHOLDERS.has(match.trim()) ? match : " ",
    )
    .replace(/[ \t]{2,}/g, " ")
    .trim();
}
